import React, { useMemo } from 'react';
import type { ChipProps } from '@mui/material';
import { alpha, Chip as MuiChip, lighten } from '@mui/material';
import { useTheme } from '@mui/styles';
import merge from 'deepmerge';

type Props = ChipProps;

const Chip: React.FC<Props> = props => {
    const theme = useTheme();
    const { variant, color, sx } = props;

    const theSx = useMemo(() => {
        const themeColor = theme?.palette?.[color]?.main;
        // a near-white tint in light mode, a faint wash of the colour in dark mode
        const outlinedChipBg = (c: string) =>
            theme.palette.mode === 'dark' ? alpha(c, 0.12) : lighten(c, 0.96);
        if (variant === 'outlined') {
            // merge this override SX with whatever other SX may have been supplied
            return merge(
                {
                    bgcolor: themeColor ? outlinedChipBg(themeColor) : theme.palette?.action?.hover,
                },
                (sx ?? {}) as any,
            ) as ChipProps['sx'];
        }

        return sx;
    }, [variant, color, sx, theme]);

    return <MuiChip {...props} sx={theSx} />;
};

export default Chip;
